import { Injectable } from '@angular/core';

import { FileLoaderService } from './file-loader.service';
import { Config } from '../interfaces/config';
import { ConfigurationConstants } from './../constants/config';

@Injectable()
export class AppConfig {

  protected config: Config;

  constructor(private _fileLoader: FileLoaderService) { }

  public loadFromFile(): void {
    this.config = <Config> this._fileLoader.load(ConfigurationConstants.CONFIG_FILE_LOCATION);
  }

  public getBaseApiUrl(): string {
    return this.config.baseUrl;
  }

  public getCompSearchApiUrl(): string {
    return this.config.compSearchApiUrl;
  }

  public getTpSafeApiUrl(): string {
    return this.config.tpSafeApiUrl;
  }

  public getComplianceCentralApiUrl(): string {
    return this.config.complianceCentralApiUrl;
  }

  public getTpReportGeneratorApiUrl(): string {
    return this.config.tpReportGeneratorApiUrl;
  }

  public getAuthUrl(): string {
    return `${this.config.authUrl}/v1/`;
  }

  public getLoginStackRelativeUrl(): string {
    return `${this.config.loginStackRelativeUrl}`;
  }
  
  public getExacteraDomainUrl(): string {
    return `${this.config.exacteraDomainUrl}`;
  }

  public getPlanningApiUrl(): string {
    return this.config.planningApiUrl + '/v1/';
  }

  public getPlanningWSUrl(): string {
    return this.config.planningWebSocketUrl;
  }

  public getTpCoreApiUrl(): string {
    return this.config.tpCoreApiUrl;
  }

  public getAdminUrl(): string {
    return this.config.adminUrl;
  }

  public getProxyUrl(): string {
    return this.config.proxyUrl;
  }

  public getPrincipleUrl(): string {
    return `${this.config.principleUrl}/v1/`;
  }

  public getEnvironment(): string {
    return this.config.xbsEnvironment;
  }

  public getEnvironmentShort(): string {
    return this.config.xbsEnvironmentShort;
  }

  public getCurrentBuildTime(): string {
    return this.config.buildTime;
  }

  public getClientAppId(): string {
    return this.config.clientAppId;
  }

  public getLaunchDarkleyKey(): string {
    return this.config.launchDarklyEnv ? this.config.launchDarklyEnv[this.config.xbsEnvironment] : '';
  }
}
